// auto-logout.service.ts
import { Injectable, NgZone } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '../_services';
import { NotifierService } from '../_services';
declare var $: any;
@Injectable({
  providedIn: 'root'
})
export class AutoLogoutService {
  private inactivityTime = 30 * 60 * 1000; // 5 minutes
  private excludedRoutes = ['/auction/bids'];
  private modalTime = 5000;
  private timeout: any;
  private intervalCheck: any;
  private modalTimer: any;
  private broadcast = new BroadcastChannel('auth_channel');
  isAuth: boolean = false;
  public showModal: boolean = false;
  public countdown: number = 60;
  private confirmCallback: () => void = () => {};

  constructor(private router: Router, private ngZone: NgZone, private _US: UserService, private _notifier: NotifierService) {
    this.init();
  }

  init() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.resetTimer();
      }
    });
    this._US.getAuth().subscribe(
        (data: any) => {
          this.isAuth = data;
        }
      )

    const events = ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, this.resetTimer.bind(this)));

    this.broadcast.onmessage = (event) => {
      if (event.data === 'logout') {
        this.logout();
      }
    };

    this.intervalCheck = setInterval(() => {
      const lastActive = parseInt(localStorage.getItem('lastActive') || '0', 10);
      if (Date.now() - lastActive >= this.inactivityTime && !this.isExcluded()) {
        this.triggerModal();
      }
    }, 60000);

    this.resetTimer();
  }

  isExcluded(): boolean {
    return this.excludedRoutes.some(path => location.pathname.startsWith(path));
  }

  resetTimer() {
    if (this.isExcluded()) return;
    clearTimeout(this.timeout);
    localStorage.setItem('lastActive', Date.now().toString());

    this.timeout = setTimeout(() => {
      this.triggerModal();
    }, this.inactivityTime);
  }

  triggerModal() {
    if (!this.isAuth || this.countdown == 0 ) return;

    this.showModal = true;
    this.countdown = 60;
    clearInterval(this.modalTimer);
    this.modalTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.modalTimer);
        this.broadcast.postMessage('logout');
        this.logout();
      }
    }, 1000);
  }

  confirmLogout() {
   
    $('#offcanvasTopSignin').offcanvas('show');
    this.showModal = false;
    clearTimeout(this.timeout);
    clearInterval(this.intervalCheck);
    clearInterval(this.modalTimer);
    window.location.reload();
  }
  continueSession() {
    this.showModal = false;
    clearTimeout(this.timeout);
    clearInterval(this.intervalCheck);
    clearInterval(this.modalTimer);
    this.countdown = 5;
    // this.broadcast.postMessage('logout');
    // this.logout();
  }
  logout() {
    this._US.logout().subscribe(
      (data: any) => {
        if (data.meta.status) {
          this._notifier.showSuccess(data.meta.msg, 'Success');
          this._US.updateUserAuth(false, null);
          localStorage.removeItem('oneHomeCurrentUser');      
          // this.router.navigate(['/']);
        } else {
          this._notifier.showSuccess(data.meta.msg, 'Error');
        }
      }
    )
  }
}
